import { Calculator } from '../components/calculator/Calculator';

export function LandingPage() {
  return <Calculator />;
}
